module.exports = {"title":"Check-in Application","description":"Please use your phone to scan the QR code.","switch":"Switch Mode"}


//////////////////
// WEBPACK FOOTER
// ./src/components/Checkin/locales/fr.json
// module id = 1391
// module chunks = 0